import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import SimpleBar from 'simplebar';

$(window).on('load', () => {
  const capacityChartsBlocks = document?.querySelectorAll('.capacity-charts__block');
  const gatherSelectPropety = document.getElementById('property');
  const capacityChartsSelect = document.getElementById('capacity-charts__properties');
  const defaultOption = capacityChartsSelect?.querySelector('.capacity-charts__default');
  const capacityChartsRow = document.querySelector('.capacity-charts__row');
  const options = capacityChartsSelect.querySelector('.capacity-charts__options');
  const optionItems = capacityChartsSelect.querySelectorAll('.capacity-charts__option');
  const proprtyCategories = document.querySelectorAll('.capacity-charts__category');

  // eslint-disable-next-line no-use-before-define
  const observer = new MutationObserver(observeContentWrappers);

  function changeTabindex(element) {
    // eslint-disable-next-line no-param-reassign
    element.tabIndex = -1;
  }

  function handleContentWrappers(contentWrappers) {
    // eslint-disable-next-line no-restricted-syntax
    for (const contentWrapper of contentWrappers) {
      changeTabindex(contentWrapper);
    }
  }

  function observeContentWrappers() {
    const contentWrappers = document.querySelectorAll('.simplebar-content-wrapper');
    if (contentWrappers.length > 0) {
      handleContentWrappers(contentWrappers);
      observer.disconnect();
    }
  }

  observer.observe(document, { childList: true, subtree: true });

  observeContentWrappers();

  const firstOption = options.firstChild;
  const lastOption = options.lastChild;

  function closeDropdown() {
    options.classList.remove('open');
    defaultOption.classList.remove('open');
  }

  firstOption.addEventListener('focusout', (event) => {
    if (!options.contains(event.relatedTarget)) {
      closeDropdown();
    }
  });

  lastOption.addEventListener('focusout', (event) => {
    if (!options.contains(event.relatedTarget)) {
      closeDropdown();
    }
  });

  document.addEventListener('click', (event) => {
    const targetElement = event.target;

    if (!capacityChartsSelect.contains(targetElement)) {
      options.classList.remove('open');
      defaultOption.classList.remove('open');
    }
  });

  defaultOption.addEventListener('click', (e) => {
    options.classList.toggle('open');
    e.target.classList.toggle('open');
  });

  const updateGatherProperty = (item) => {
    const propertyName = item?.textContent;
    const gatherOptions = gatherSelectPropety.querySelectorAll('option');
    Array.from(gatherOptions).forEach((option) => {
      if (option.textContent.includes(propertyName)) {
        const newPropertyValue = option.value;
        gatherSelectPropety.value = newPropertyValue;
      }
    });
  };

  // Update URL query string
  const updateQueryString = (key, value) => {
    const url = new URL(window.location);
    url.searchParams.set(key, value);
    window.history.pushState({}, '', url);
  };

  const updatePropertyList = (item) => {
    defaultOption.textContent = item.textContent;
    const currentProperty = item.dataset.hash;
    const visibleTable = document?.querySelector(`.capacity-charts__block[data-hash="${currentProperty}"]`);
    capacityChartsBlocks.forEach((el) => el.classList.add('hidden'));
    visibleTable?.classList.remove('hidden');
    options.classList.remove('open');
    defaultOption.classList.remove('open');
    if (visibleTable === null) {
      options.classList.add('without-table');
      capacityChartsRow.classList.add('without-table');
    } else {
      options.classList.remove('without-table');
      capacityChartsRow.classList.remove('without-table');
    }
    updateQueryString('property', currentProperty);
  };

  optionItems.forEach((item) => {
    item.addEventListener('click', () => {
      updateGatherProperty(item);
      updatePropertyList(item);
    });
  });

  proprtyCategories.forEach((item) => {
    if (!item.nextElementSibling?.classList.contains('capacity-charts__option')) {
      item.remove();
    }
  });

  const propertyIDs = Array.from(optionItems, (item) => item.dataset.hash);
  const loadedPropertyID = localStorage.getItem('propertyID');

  function openCapacityCharts(propertyID) {
    if (propertyID !== null && propertyIDs.includes(propertyID)) {
      const chosenAfterLoadingOption = document?.querySelector(`.capacity-charts__option[data-hash="${String(propertyID)}"]`);
      const chosenAfterLoadingBlock = document?.querySelector(`.capacity-charts__block[data-hash="${String(propertyID)}"]`);
      defaultOption.textContent = chosenAfterLoadingOption?.textContent;
      chosenAfterLoadingBlock?.classList.remove('hidden');
      localStorage.removeItem('propertyID');
      updateGatherProperty(chosenAfterLoadingOption);
    } else {
      for (let i = 0; i < capacityChartsBlocks.length; i++) {
        const el = capacityChartsBlocks[i];
        if (el.dataset.hash.length > 0) {
          const currentHash = el.dataset.hash;
          const currentEl = document?.querySelector(`.capacity-charts__option[data-hash="${String(currentHash)}"]`);
          defaultOption.textContent = currentEl?.textContent;
          updateGatherProperty(currentEl);
          el.classList.remove('hidden');
          break;
        }
      }
    }
  }

  function isPropertyMeetings(propertyName) {
    return new Promise((resolve, reject) => {
      optionItems.forEach((option) => {
        if (option.textContent.toLocaleLowerCase().includes(propertyName.split('-').join(' '))) {
          localStorage.removeItem('propertyID');
          localStorage.setItem('propertyID', option.dataset.hash);
          updateGatherProperty(option);
          updatePropertyList(option);
          resolve(option.dataset.hash);
        }
      });
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('Property not found');
    });
  }

  function handlePropertyMeetings(propertyName) {
    if (loadedPropertyID && propertyIDs.includes(loadedPropertyID)) {
      openCapacityCharts(loadedPropertyID);
    } else {
      isPropertyMeetings(propertyName)
        .then((propertyID) => openCapacityCharts(propertyID))
        .catch((error) => {
          console.error(error);
          openCapacityCharts(loadedPropertyID);
        });
    }
  }

  const previousUrl = document.referrer;
  const propertyName = previousUrl.split('/')[3];
  const meetingPage = previousUrl.split('/')[5];

  if (propertyName?.length > 0 && meetingPage === 'meetings') {
    handlePropertyMeetings(propertyName);
  } else {
    openCapacityCharts(loadedPropertyID);
  }

  // Preserve selected property after page reload / passed $_GET parameter
  const urlParams = new URLSearchParams(window.location.search);
  const preSelectProperty = urlParams.get('property');
  if (preSelectProperty) {
    const preSelectOption = document.querySelector(`.capacity-charts__option[data-hash="${preSelectProperty}"]`);
    if (preSelectOption) {
      updateGatherProperty(preSelectOption);
      updatePropertyList(preSelectOption);
    }
  }
});
